import React, { forwardRef } from 'react';
import classNames from 'classnames';
import styles from './Button.module.css';

const Button = forwardRef(function Button(
  { type = 'button', variant, size, color, className, component: Component = 'button', start, end, children, ...rest },
  forwardedRef
) {
  return (
    <Component
      ref={forwardedRef}
      {...(Component === 'button' ? { type } : {})}
      className={classNames(styles.root, styles[variant], styles[color], styles[size], className)}
      {...rest}
    >
      {start && <span className={styles.start}>{start}</span>}
      {children}
      {end && <span className={styles.end}>{end}</span>}
    </Component>
  );
});

export default Button;
